import { toast } from "react-toastify";
import {
  CampaignsContainer,
  CampaignSearchContainer,
} from "../components/Campaign/index.js";
import { useLoaderData } from "react-router-dom";
import { customFetch } from "../utils/custom-fetch.js";
import { useContext, createContext } from "react";
import { useNavigate } from "react-router-dom";
export const loader = async ({ request }) => {
  const params = Object.fromEntries([
    ...new URL(request.url).searchParams.entries(),
  ]);

  try {
    const { data } = await customFetch.get("/campaigns", {
      params,
    });

    const companies = await customFetch.get("/buildings/maintenance-companies");
    const maintenanceCompanies = [
      ...companies.data.map((company) => ({
        name: company.name,
        _id: company.value,
      })),
    ];
    
    return { data, maintenanceCompanies };
  } catch (error) {
    toast.error(error?.response?.data?.msg || "Error fetching campaigns");
    return error;
  }
};

const AllCampaignsContext = createContext();

const AllCampaigns = () => {
  const { data, maintenanceCompanies } = useLoaderData();
  const navigate = useNavigate();
  return (
    <AllCampaignsContext.Provider value={{ data, maintenanceCompanies }}>
      <button
        type="button"
        style={{ marginBottom: "1rem" }}
        className="btn btn-primary"
        onClick={() => navigate("/dashboard/advertiser-request")}
      >
        צור קמפיין חדש
      </button>
      <CampaignSearchContainer />
      <CampaignsContainer />
    </AllCampaignsContext.Provider>
  );
};

export const useAllCampaignsContext = () => useContext(AllCampaignsContext);

export default AllCampaigns;
